import { Box, Checkbox, Paper, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export function OrderBookingConfig() {
  const { control } = useFormContext();

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Typography fontWeight={600}>Order Types</Typography>
      <Typography variant='body2' color='text.secondary' mb={2}>
        Select which order types the agent should handle.
      </Typography>

      <Controller
        name='order_booking_details.order_type' // ✅ BE KEY
        control={control}
        defaultValue={{ pickup: false, delivery: false }}
        render={({ field }) => {
          const value = field.value || {};

          const options = [
            { label: 'Pickup', key: 'pickup' },
            { label: 'Delivery', key: 'delivery' }
          ];

          return (
            <Box display='flex' gap={2} mt={1}>
              {options.map((opt) => {
                const checked = Boolean(value[opt.key]);

                return (
                  <Paper
                    key={opt.key}
                    variant='outlined'
                    sx={{
                      pr: 1,
                      py: 0.4,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      cursor: 'pointer',
                      borderColor: checked ? '#1976d2' : '#EAEAEA',
                      bgcolor: checked ? '#E3F2FD' : '#fff'
                    }}
                    onClick={() => {
                      field.onChange({
                        ...value,
                        [opt.key]: !checked
                      });
                    }}
                  >
                    <Checkbox checked={checked} />
                    <Typography>{opt.label}</Typography>
                  </Paper>
                );
              })}
            </Box>
          );
        }}
      />
    </Paper>
  );
}
